/* eslint-disable import/first */

if (process.env.NODE_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at the top of a file.
  require('preact/debug');
}

import { formatDefaultLocale } from 'd3-format';
import * as React from 'react';
import { render } from 'preact';
import { enableAllPlugins } from 'immer';

import { locale } from './constants';
import App from './App';

enableAllPlugins();

// Set the Dutch (nl-NL) locale as the default locale.
formatDefaultLocale(locale);

render(<App />, document.getElementById('root'));
